'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: ', ';\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 41;\n  background-color: ', ';\n'], ['\n  position: ', ';\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 41;\n  background-color: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 12px;\n'], ['\n  position: absolute;\n  left: 12px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n  ', ';\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n  ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    justify-content: left;\n    flex-direction: row;\n  '], ['\n    justify-content: left;\n    flex-direction: row;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n'], ['\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  padding: ', ' ', ';\n  ', ';\n  > \n'], ['\n  display: flex;\n  flex-direction: column;\n  padding: ', ' ', ';\n  ', ';\n  > \n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    flex-direction: row;\n    padding-top: 0;\n    padding-bottom: 0;\n  '], ['\n    flex-direction: row;\n    padding-top: 0;\n    padding-bottom: 0;\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  justify-content: space-between;\n  margin: 0;\n  ', ' {\n    background-color: ', ';\n    justify-content: space-between;\n  }\n  ', ';\n  ', ';\n'], ['\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  justify-content: space-between;\n  margin: 0;\n  ', ' {\n    background-color: ', ';\n    justify-content: space-between;\n  }\n  ', ';\n  ', ';\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n    height: ', ';\n    flex-direction: row;\n    align-items: center;\n    ', ' {\n      background-color: transparent;\n    }\n  '], ['\n    height: ', ';\n    flex-direction: row;\n    align-items: center;\n    ', ' {\n      background-color: transparent;\n    }\n  ']),
    _templateObject11 = _taggedTemplateLiteral(['\n     ', ' {\n      justify-content: flex-end;\n     }\n  '], ['\n     ', ' {\n      justify-content: flex-end;\n     }\n  ']),
    _templateObject12 = _taggedTemplateLiteral(['\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0 ', ';\n  background-color: ', ';\n  ', ' {\n    display: none;\n    padding: 0;\n  }\n  ', ' {\n    width: 100%;\n    justify-content: space-between;\n  }\n  ', ';\n'], ['\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0 ', ';\n  background-color: ', ';\n  ', ' {\n    display: none;\n    padding: 0;\n  }\n  ', ' {\n    width: 100%;\n    justify-content: space-between;\n  }\n  ', ';\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n    ', ' {\n      display: flex;\n    }\n    ', ' {\n      width: auto;\n    }\n  '], ['\n    ', ' {\n      display: flex;\n    }\n    ', ' {\n      width: auto;\n    }\n  ']),
    _templateObject14 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  ', ';\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  ', ';\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n  justify-content: flex-start;\n'], ['\n  justify-content: flex-start;\n']),
    _templateObject16 = _taggedTemplateLiteral(['\n  line-height: 0;\n'], ['\n  line-height: 0;\n']),
    _templateObject17 = _taggedTemplateLiteral(['\n  max-width: 100%;\n  height: ', ';\n'], ['\n  max-width: 100%;\n  height: ', ';\n']),
    _templateObject18 = _taggedTemplateLiteral(['\n  font-size: ', ';\n  text-align: left;\n  color: ', ';\n  padding: ', ' ', ';\n  display: flex;\n  align-items: center;\n  position: relative;\n  ', ';\n'], ['\n  font-size: ', ';\n  text-align: left;\n  color: ', ';\n  padding: ', ' ', ';\n  display: flex;\n  align-items: center;\n  position: relative;\n  ', ';\n']),
    _templateObject19 = _taggedTemplateLiteral(['\n  display: flex;\n'], ['\n  display: flex;\n']),
    _templateObject20 = _taggedTemplateLiteral(['\n  margin-left: ', ';\n'], ['\n  margin-left: ', ';\n']),
    _templateObject21 = _taggedTemplateLiteral(['\n  display: none;\n  ', ';\n'], ['\n  display: none;\n  ', ';\n']),
    _templateObject22 = _taggedTemplateLiteral(['\n    display: block;\n  '], ['\n    display: block;\n  ']),
    _templateObject23 = _taggedTemplateLiteral(['\n  text-transform: uppercase;\n  line-height: 1.2;\n  max-width: ', ';\n  ', ';\n'], ['\n  text-transform: uppercase;\n  line-height: 1.2;\n  max-width: ', ';\n  ', ';\n']),
    _templateObject24 = _taggedTemplateLiteral(['\n    text-transform: none;\n    line-height: inherit;\n    max-width: none;\n  '], ['\n    text-transform: none;\n    line-height: inherit;\n    max-width: none;\n  ']),
    _templateObject25 = _taggedTemplateLiteral(['\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  color: white;\n  font-size: 14px;\n  font-weight: 300;\n  width: 100%;\n  cursor: pointer;\n  &:hover {\n    /* text-decoration: underline; */\n    background: #5e9006;\n  }\n'], ['\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  color: white;\n  font-size: 14px;\n  font-weight: 300;\n  width: 100%;\n  cursor: pointer;\n  &:hover {\n    /* text-decoration: underline; */\n    background: #5e9006;\n  }\n']),
    _templateObject26 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  box-shadow: 0 ', ' ', ' 0 #70af00;\n  right: 0;\n  top: ', ';\n  padding-top: ', ';\n  padding-bottom: ', ';\n  z-index: 1;\n  width: ', ';\n  min-height: ', ';\n  background-color: #70af00;\n  &:hover {\n    cursor: default;\n  }\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: ', ';\n    border: ', ' solid transparent;\n    border-bottom: ', ' solid #70af00;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  box-shadow: 0 ', ' ', ' 0 #70af00;\n  right: 0;\n  top: ', ';\n  padding-top: ', ';\n  padding-bottom: ', ';\n  z-index: 1;\n  width: ', ';\n  min-height: ', ';\n  background-color: #70af00;\n  &:hover {\n    cursor: default;\n  }\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: ', ';\n    border: ', ' solid transparent;\n    border-bottom: ', ' solid #70af00;\n  }\n']),
    _templateObject27 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  box-shadow: 0 ', ' ', ' 0 #70af00;\n  right: ', ';\n  top: ', ';\n  z-index: 2;\n  width: ', ';\n  /* min-height: ', '; */\n  background-color: #c2ccd5;\n  &:hover {\n    cursor: default;\n  }\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: ', ';\n    right: 25%;\n    border: 10px solid transparent;\n    border-bottom: 10px solid #c2ccd5;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  box-shadow: 0 ', ' ', ' 0 #70af00;\n  right: ', ';\n  top: ', ';\n  z-index: 2;\n  width: ', ';\n  /* min-height: ', '; */\n  background-color: #c2ccd5;\n  &:hover {\n    cursor: default;\n  }\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: ', ';\n    right: 25%;\n    border: 10px solid transparent;\n    border-bottom: 10px solid #c2ccd5;\n  }\n']),
    _templateObject28 = _taggedTemplateLiteral(['\n  font-size: ', ';\n  font-weight: 400;\n  padding: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n'], ['\n  font-size: ', ';\n  font-weight: 400;\n  padding: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n']),
    _templateObject29 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  background-color: white;\n  width: 100%;\n  height: ', ';\n'], ['\n  display: flex;\n  flex-direction: row;\n  background-color: white;\n  width: 100%;\n  height: ', ';\n']),
    _templateObject30 = _taggedTemplateLiteral(['\n  width: 30%;\n  max-width: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  width: 30%;\n  max-width: ', ';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),
    _templateObject31 = _taggedTemplateLiteral(['\n  width: 70%;\n  padding-top: ', ';\n  padding-right: ', ';\n'], ['\n  width: 70%;\n  padding-top: ', ';\n  padding-right: ', ';\n']),
    _templateObject32 = _taggedTemplateLiteral(['\n  height: ', ';\n  width: 100%;\n  font-size: ', ';\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  height: ', ';\n  width: 100%;\n  font-size: ', ';\n  margin-top: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject33 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n']),
    _templateObject34 = _taggedTemplateLiteral(['\n  font-size: ', ';\n'], ['\n  font-size: ', ';\n']),
    _templateObject35 = _taggedTemplateLiteral(['\n  text-align: right;\n\n  font-size: ', ';\n'], ['\n  text-align: right;\n\n  font-size: ', ';\n']),
    _templateObject36 = _taggedTemplateLiteral(['\n  width: 100%;\n  font-size: ', ';\n  height: ', ';\n'], ['\n  width: 100%;\n  font-size: ', ';\n  height: ', ';\n']),
    _templateObject37 = _taggedTemplateLiteral(['\n  font-size: ', ';\n  font-weight: 300;\n  margin-bottom: 0;\n  color: ', ';\n  display: none;\n  ', ';\n'], ['\n  font-size: ', ';\n  font-weight: 300;\n  margin-bottom: 0;\n  color: ', ';\n  display: none;\n  ', ';\n']),
    _templateObject38 = _taggedTemplateLiteral(['\n  padding: ', ' 0 ', ';\n  width: 100%;\n  display: none;\n  ', ';\n'], ['\n  padding: ', ' 0 ', ';\n  width: 100%;\n  display: none;\n  ', ';\n']),
    _templateObject39 = _taggedTemplateLiteral(['\n  display: flex;\n    border-left: ', ' solid ', ';\n    padding: ', ' 0 ', ' ', ';\n    min-width: ', ';\n  '], ['\n  display: flex;\n    border-left: ', ' solid ', ';\n    padding: ', ' 0 ', ' ', ';\n    min-width: ', ';\n  ']),
    _templateObject40 = _taggedTemplateLiteral(['\n  display: flex;\n  padding: ', ' 0 ', ';\n  width: 100%;\n  ', ';\n'], ['\n  display: flex;\n  padding: ', ' 0 ', ';\n  width: 100%;\n  ', ';\n']),
    _templateObject41 = _taggedTemplateLiteral(['\n  display: none;\n    border-left: ', ' solid ', ';\n    padding: ', ' 0 ', ' ', ';\n    min-width: ', ';\n  '], ['\n  display: none;\n    border-left: ', ' solid ', ';\n    padding: ', ' 0 ', ' ', ';\n    min-width: ', ';\n  ']),
    _templateObject42 = _taggedTemplateLiteral(['\n  border: 0;\n  background: transparent;\n  margin-right: ', ';\n  &:hover,\n  &:focus {\n    background: transparent;\n  }\n'], ['\n  border: 0;\n  background: transparent;\n  margin-right: ', ';\n  &:hover,\n  &:focus {\n    background: transparent;\n  }\n']),
    _templateObject43 = _taggedTemplateLiteral(['\n  border: 0;\n  background: #3e3c3c;\n  margin-right: ', ';\n  width: ', ';\n  height: ', ';\n  margin-left: ', ';\n  &:hover,\n  &:focus {\n    background: #3e3c3c;\n  }\n  ', ';\n'], ['\n  border: 0;\n  background: #3e3c3c;\n  margin-right: ', ';\n  width: ', ';\n  height: ', ';\n  margin-left: ', ';\n  &:hover,\n  &:focus {\n    background: #3e3c3c;\n  }\n  ', ';\n']),
    _templateObject44 = _taggedTemplateLiteral(['\n  display: none;\n'], ['\n  display: none;\n']),
    _templateObject45 = _taggedTemplateLiteral(['\n  margin-right: 12px;\n  border-radius: ', ';\n  height: ', ';\n  width: 100%;\n'], ['\n  margin-right: 12px;\n  border-radius: ', ';\n  height: ', ';\n  width: 100%;\n']),
    _templateObject46 = _taggedTemplateLiteral(['\n  min-width: ', ';\n  width: 97%;\n  margin-top: ', ';\n  ', ';\n'], ['\n  min-width: ', ';\n  width: 97%;\n  margin-top: ', ';\n  ', ';\n']),
    _templateObject47 = _taggedTemplateLiteral(['\n  margin-top: ', '\n  max-width: ', ';\n'], ['\n  margin-top: ', '\n  max-width: ', ';\n']),
    _templateObject48 = _taggedTemplateLiteral(['\n  padding-right: ', ';\n  padding-left: ', ';\n  width: 100%;\n  display: none;\n  ', ';\n'], ['\n  padding-right: ', ';\n  padding-left: ', ';\n  width: 100%;\n  display: none;\n  ', ';\n']),
    _templateObject49 = _taggedTemplateLiteral(['\nmax-width: ', ';\ndisplay: flex;\n'], ['\nmax-width: ', ';\ndisplay: flex;\n']),
    _templateObject50 = _taggedTemplateLiteral(['\n  color: white;\n  width: 100%;\n  font-size: ', ';\n  font-weight: 500;\n  display: none;\n  ', ';\n'], ['\n  color: white;\n  width: 100%;\n  font-size: ', ';\n  font-weight: 500;\n  display: none;\n  ', ';\n']),
    _templateObject51 = _taggedTemplateLiteral(['\n  display: flex;\n  '], ['\n  display: flex;\n  ']),
    _templateObject52 = _taggedTemplateLiteral([''], ['']),
    _templateObject53 = _taggedTemplateLiteral(['\n  margin-bottom: ', ';\n'], ['\n  margin-bottom: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18n = require('react-i18n');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _Select = require('../Select');

var _Select2 = _interopRequireDefault(_Select);

var _Heading = require('../Heading/Heading');

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
  var position = _ref.position;
  return position || 'absolute';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.primaryBg;
});

var HeaderMenuIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject2);

var RightWrapper = _styledComponents2.default.div(_templateObject3, function (_ref3) {
  var theme = _ref3.theme;
  return theme.media.m(_templateObject4);
});

var RightSubWrapper = _styledComponents2.default.div(_templateObject5);

var RightSubSubWrapper = _styledComponents2.default.div(_templateObject6);

var LeftWrapper = _styledComponents2.default.div(_templateObject7, (0, _polished.rem)(12), (0, _polished.rem)(20), function (_ref4) {
  var theme = _ref4.theme;
  return theme.media.m(_templateObject8);
});

var TopWrapper = _styledComponents2.default.div(_templateObject9, RightWrapper, function (_ref5) {
  var theme = _ref5.theme;
  return theme.header.secondaryBg;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.media.m(_templateObject10, (0, _polished.rem)(70), RightWrapper);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.media.xs(_templateObject11, RightWrapper);
});

var BottomWrapper = _styledComponents2.default.div(_templateObject12, (0, _polished.rem)(20), function (_ref8) {
  var theme = _ref8.theme;
  return theme.color.gray;
}, LeftWrapper, RightWrapper, function (_ref9) {
  var theme = _ref9.theme;
  return theme.media.m(_templateObject13, LeftWrapper, RightWrapper);
});

var TitleWrapper = _styledComponents2.default.div(_templateObject14, function (_ref10) {
  var theme = _ref10.theme;
  return theme.media.m(_templateObject15);
});

var LogoWrapper = _styledComponents2.default.a(_templateObject16);

var Logo = _styledComponents2.default.img(_templateObject17, (0, _polished.rem)(46));

var Item = _styledComponents2.default.div(_templateObject18, function (_ref11) {
  var theme = _ref11.theme;
  return theme.font.fontSizeS;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.color.textColor;
}, (0, _polished.rem)(16), (0, _polished.rem)(15), function (props) {
  return props.onClick ? ':hover {\n      cursor: pointer;\n    }' : '';
});

var FlexIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject19);

var Text = _styledComponents2.default.span(_templateObject20, (0, _polished.rem)(15));

var CartSumText = (0, _styledComponents2.default)(Text)(_templateObject21, function (_ref13) {
  var theme = _ref13.theme;
  return theme.media.xs(_templateObject22);
});

var ProfileText = (0, _styledComponents2.default)(Text)(_templateObject23, (0, _polished.rem)(70), function (_ref14) {
  var theme = _ref14.theme;
  return theme.media.xs(_templateObject24);
});

var HeaderItem = _styledComponents2.default.div(_templateObject25);

var LogoutPopup = _styledComponents2.default.div(_templateObject26, (0, _polished.rem)(1), (0, _polished.rem)(1), function (props) {
  return (0, _polished.rem)(props.menuOffset);
}, (0, _polished.rem)(10), (0, _polished.rem)(10), (0, _polished.rem)(200), (0, _polished.rem)(100), (0, _polished.rem)(-20), (0, _polished.rem)(10), (0, _polished.rem)(10));

var CartPopup = _styledComponents2.default.div(_templateObject27, (0, _polished.rem)(1), (0, _polished.rem)(1), (0, _polished.rem)(-40), function (props) {
  return (0, _polished.rem)(props.menuOffset);
}, (0, _polished.rem)(350), (0, _polished.rem)(100), (0, _polished.rem)(-20));

var CartText = _styledComponents2.default.div(_templateObject28, (0, _polished.rem)(14), (0, _polished.rem)(6));

var CartItem = _styledComponents2.default.div(_templateObject29, (0, _polished.rem)(85));

var CartImageWrapper = _styledComponents2.default.div(_templateObject30, (0, _polished.rem)(75));

var CartRightSideWrapper = _styledComponents2.default.div(_templateObject31, (0, _polished.rem)(10), (0, _polished.rem)(8));

var CartItemName = _styledComponents2.default.div(_templateObject32, (0, _polished.rem)(35), (0, _polished.rem)(14));

var CartItemInfo = _styledComponents2.default.div(_templateObject33);

var CartItemQuantity = _styledComponents2.default.div(_templateObject34, (0, _polished.rem)(14));

var CartItemPrice = _styledComponents2.default.div(_templateObject35, (0, _polished.rem)(14));

var CartButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject36, (0, _polished.rem)(14), (0, _polished.rem)(48));

var OrderButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject21, function (_ref15) {
  var theme = _ref15.theme;
  return theme.media.m(_templateObject22);
});

var PageTitle = (0, _styledComponents2.default)(_Heading.H1)(_templateObject37, function (_ref16) {
  var theme = _ref16.theme;
  return theme.font.fontSizeM;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.color.white;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.media.m(_templateObject22);
});

var SearchForm = _styledComponents2.default.div(_templateObject38, (0, _polished.rem)(6), (0, _polished.rem)(6), function (_ref19) {
  var theme = _ref19.theme;
  return theme.media.m(_templateObject39, (0, _polished.rem)(1), theme.form.searchBorderColor, (0, _polished.rem)(6), (0, _polished.rem)(6), (0, _polished.rem)(15), (0, _polished.rem)(220));
});

var SearchFormMobile = _styledComponents2.default.div(_templateObject40, (0, _polished.rem)(6), (0, _polished.rem)(6), function (_ref20) {
  var theme = _ref20.theme;
  return theme.media.m(_templateObject41, (0, _polished.rem)(1), theme.form.searchBorderColor, (0, _polished.rem)(6), (0, _polished.rem)(6), (0, _polished.rem)(15), (0, _polished.rem)(220));
});

var SearchButton = (0, _styledComponents2.default)(_Button2.default)(_templateObject42, (0, _polished.rem)(15));
var SearchButtonMobile = (0, _styledComponents2.default)(_Button2.default)(_templateObject43, (0, _polished.rem)(15), (0, _polished.rem)(50), (0, _polished.rem)(50), (0, _polished.rem)(8), function (_ref21) {
  var theme = _ref21.theme;
  return theme.media.m(_templateObject44);
});

var SearchInput = (0, _styledComponents2.default)(_Input2.default)(_templateObject45, (0, _polished.rem)(2), (0, _polished.rem)(32));
var StyledSelect = (0, _styledComponents2.default)(_Select2.default)(_templateObject46, (0, _polished.rem)(180), (0, _polished.rem)(10), function (_ref22) {
  var theme = _ref22.theme;
  return theme.media.m(_templateObject47, (0, _polished.rem)(0), (0, _polished.rem)(200));
});

var CartsWrapper = _styledComponents2.default.div(_templateObject48, (0, _polished.rem)(3), (0, _polished.rem)(15), function (_ref23) {
  var theme = _ref23.theme;
  return theme.media.m(_templateObject49, (0, _polished.rem)(220));
});

var NameDayWrapper = _styledComponents2.default.div(_templateObject50, (0, _polished.rem)(14), function (_ref24) {
  var theme = _ref24.theme;
  return theme.media.m(_templateObject51);
});

var Tomorrow = _styledComponents2.default.div(_templateObject52);

var Today = _styledComponents2.default.div(_templateObject53, (0, _polished.rem)(4));

var Header = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.renderTitle = _this.renderTitle.bind(_this);
    _this.onUserClick = _this.onUserClick.bind(_this);
    _this.onCartClick = _this.onCartClick.bind(_this);
    _this.state = {
      searchText: '',
      showLogoutPopup: false,
      showCartPopup: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: 'onUserClick',
    value: function onUserClick() {
      this.setState({
        showLogoutPopup: true,
        showCartPopup: false
      });
    }
  }, {
    key: 'onCartClick',
    value: function onCartClick() {
      this.setState({
        showCartPopup: true,
        showLogoutPopup: false
      });
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(event) {
      if (event.key === 'Enter') {
        this.setState({
          showSearchMobile: false
        });

        this.props.onSearch(this.state.searchText);
      }
    }
  }, {
    key: 'cartItemsText',
    value: function cartItemsText() {
      var _props = this.props,
          activeCartContent = _props.activeCartContent,
          maxCartItems = _props.maxCartItems,
          emptyCartTitle = _props.emptyCartTitle;


      if (activeCartContent.length === 0) return emptyCartTitle;
      if (activeCartContent.length > maxCartItems) {
        if (activeCartContent.length - maxCartItems === 1) {
          return (0, _reactI18n.__)('+ ' + (activeCartContent.length - maxCartItems) + ' \u010Fal\u0161ia ...');
        } else if ([2, 3, 4].includes(activeCartContent.length - maxCartItems)) {
          return (0, _reactI18n.__)('+ ' + (activeCartContent.length - maxCartItems) + ' \u010Fal\u0161ie ...');
        }
        return (0, _reactI18n.__)('+ ' + (activeCartContent.length - maxCartItems) + ' \u010Fal\u0161\xEDch ...');
      }
      return '';
    }
  }, {
    key: 'renderTitle',
    value: function renderTitle() {
      return _react2.default.createElement(
        TitleWrapper,
        null,
        this.props.logo && _react2.default.createElement(
          LogoWrapper,
          { href: '/' },
          _react2.default.createElement(Logo, { alt: 'logo', src: this.props.logo })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          className = _props2.className,
          onNewOrder = _props2.onNewOrder,
          onNewProduct = _props2.onNewProduct,
          onCart = _props2.onCart,
          cartSum = _props2.cartSum,
          name = _props2.name,
          logoutMethod = _props2.logoutMethod,
          onSettings = _props2.onSettings,
          pageTitle = _props2.pageTitle,
          onSearch = _props2.onSearch,
          carts = _props2.carts,
          selectedCart = _props2.selectedCart,
          changeCart = _props2.changeCart,
          nameDayToday = _props2.nameDayToday,
          nameDayTomorrow = _props2.nameDayTomorrow,
          headerMenuItems = _props2.headerMenuItems,
          activeCartContent = _props2.activeCartContent,
          maxCartItems = _props2.maxCartItems,
          searchPlaceholder = _props2.searchPlaceholder,
          nameDayLabel = _props2.nameDayLabel,
          tomorrowLabel = _props2.tomorrowLabel;
      var _state = this.state,
          showLogoutPopup = _state.showLogoutPopup,
          showCartPopup = _state.showCartPopup,
          showSearchMobile = _state.showSearchMobile;


      return _react2.default.createElement(
        Wrapper,
        {
          position: this.props.position,
          className: className,
          onMouseLeave: function onMouseLeave() {
            return _this2.setState({
              showLogoutPopup: false,
              showCartPopup: false
            });
          }
        },
        _react2.default.createElement(
          TopWrapper,
          null,
          _react2.default.createElement(
            LeftWrapper,
            null,
            this.renderTitle()
          ),
          _react2.default.createElement(
            RightWrapper,
            null,
            carts && _react2.default.createElement(
              CartsWrapper,
              null,
              _react2.default.createElement(
                StyledSelect,
                {
                  icon: 'arrow-down',
                  onChange: function onChange(e) {
                    return changeCart(e);
                  },
                  size: 's'
                },
                carts.map(function (cart) {
                  return _react2.default.createElement(
                    'option',
                    {
                      selected: cart._id === selectedCart,
                      value: cart._id
                    },
                    cart.title === 'cart1' ? (0, _reactI18n.__)('Môj košík') : cart.title
                  );
                })
              )
            ),
            _react2.default.createElement(
              OrderButton,
              { extrasmall: true, onClick: onNewProduct, primary: true },
              this.props.addLabel
            ),
            _react2.default.createElement(
              RightSubWrapper,
              null,
              !showSearchMobile && _react2.default.createElement(SearchButtonMobile, {
                primary: true,
                iconOnly: true,
                icon: 'search',
                size: 'm',
                onClick: function onClick() {
                  return _this2.setState({
                    showSearchMobile: true
                  });
                }
              }),
              _react2.default.createElement(
                RightSubSubWrapper,
                null,
                onCart && _react2.default.createElement(
                  Item,
                  { onClick: onCart, onMouseOver: this.onCartClick },
                  _react2.default.createElement(FlexIcon, { size: 'xl', color: '#bac0c9', name: 'cart' }),
                  _react2.default.createElement(
                    CartSumText,
                    null,
                    cartSum
                  ),
                  showCartPopup && _react2.default.createElement(
                    CartPopup,
                    { menuOffset: this.props.menuOffset },
                    activeCartContent.slice(0, maxCartItems).map(function (i) {
                      return _react2.default.createElement(
                        CartItem,
                        { key: i.item_name },
                        _react2.default.createElement(
                          CartImageWrapper,
                          null,
                          i.image_content
                        ),
                        _react2.default.createElement(
                          CartRightSideWrapper,
                          null,
                          _react2.default.createElement(
                            CartItemName,
                            null,
                            i.item_name
                          ),
                          _react2.default.createElement(
                            CartItemInfo,
                            null,
                            _react2.default.createElement(
                              CartItemQuantity,
                              null,
                              i.quantity,
                              ' ',
                              (0, _reactI18n.__)('ks')
                            ),
                            _react2.default.createElement(
                              CartItemPrice,
                              null,
                              i.price
                            )
                          )
                        )
                      );
                    }),
                    (activeCartContent.length > maxCartItems || !activeCartContent.length) && _react2.default.createElement(
                      CartText,
                      { onClick: onCart },
                      this.cartItemsText()
                    ),
                    _react2.default.createElement(
                      CartButton,
                      { primary: true, onClick: onCart },
                      this.props.toCartTitle
                    )
                  )
                ),
                name && _react2.default.createElement(
                  Item,
                  { onClick: this.onUserClick },
                  _react2.default.createElement(FlexIcon, { size: 'xl', color: '#bac0c9', name: 'profile' }),
                  _react2.default.createElement(
                    ProfileText,
                    null,
                    name
                  ),
                  showLogoutPopup && _react2.default.createElement(
                    LogoutPopup,
                    { menuOffset: this.props.menuOffset },
                    headerMenuItems.filter(function (h) {
                      return h.rolesExcluded.indexOf(_this2.props.role) === -1;
                    }).map(function (h) {
                      return _react2.default.createElement(
                        HeaderItem,
                        { onClick: function onClick() {
                            return h.onClick();
                          } },
                        _react2.default.createElement(HeaderMenuIcon, { name: h.icon, color: 'white' }),
                        h.label
                      );
                    })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          BottomWrapper,
          null,
          _react2.default.createElement(
            LeftWrapper,
            null,
            _react2.default.createElement(
              PageTitle,
              null,
              pageTitle
            )
          ),
          _react2.default.createElement(
            RightWrapper,
            null,
            _react2.default.createElement(
              NameDayWrapper,
              null,
              _react2.default.createElement(
                Today,
                null,
                nameDayLabel + ' ' + nameDayToday + ','
              ),
              _react2.default.createElement(
                Tomorrow,
                null,
                tomorrowLabel + ' ' + nameDayTomorrow
              )
            ),
            _react2.default.createElement(
              SearchForm,
              null,
              _react2.default.createElement(SearchButton, {
                primary: true,
                iconOnly: true,
                icon: 'search',
                size: 'm',
                onClick: function onClick() {
                  return onSearch(_this2.state.searchText);
                }
              }),
              _react2.default.createElement(SearchInput, {
                type: 'text',
                placeholder: searchPlaceholder,
                value: this.state.searchText,
                onKeyPress: function onKeyPress(e) {
                  return _this2.handleKeyPress(e);
                },
                onChange: function onChange(e) {
                  return _this2.setState({
                    searchText: e.target.value
                  });
                }
              })
            ),
            showSearchMobile && _react2.default.createElement(
              SearchFormMobile,
              null,
              _react2.default.createElement(SearchButton, {
                primary: true,
                iconOnly: true,
                icon: 'search',
                size: 'm',
                onClick: function onClick() {
                  _this2.setState({
                    showSearchMobile: false
                  });
                  onSearch(_this2.state.searchText);
                }
              }),
              _react2.default.createElement(SearchInput, {
                type: 'text',
                placeholder: searchPlaceholder,
                value: this.state.searchText,
                onKeyPress: function onKeyPress(e) {
                  return _this2.handleKeyPress(e);
                },
                onChange: function onChange(e) {
                  return _this2.setState({
                    searchText: e.target.value
                  });
                }
              })
            )
          )
        )
      );
    }
  }]);

  return Header;
}(_react.PureComponent);

Header.propTypes = {
  name: _propTypes2.default.string,
  pageTitle: _propTypes2.default.string,
  cartSum: _propTypes2.default.string,
  onNewOrder: _propTypes2.default.func,
  onNewProduct: _propTypes2.default.func,
  onCart: _propTypes2.default.func,
  logoutMethod: _propTypes2.default.func,
  changeCart: _propTypes2.default.func,
  onSettings: _propTypes2.default.func,
  onSearch: _propTypes2.default.func,
  logo: _propTypes2.default.string,
  className: _propTypes2.default.string,
  nameDayToday: _propTypes2.default.string,
  nameDayTomorrow: _propTypes2.default.string,
  selectedCart: _propTypes2.default.string,
  carts: _propTypes2.default.arrayOf({}),
  headerMenuItems: _propTypes2.default.arrayOf({}),
  activeCartContent: _propTypes2.default.arrayOf({}),
  maxCartItems: _propTypes2.default.number,
  role: _propTypes2.default.string,
  menuOffset: _propTypes2.default.number,
  toCartTitle: _propTypes2.default.string,
  addLabel: _propTypes2.default.string,
  searchPlaceholder: _propTypes2.default.string,
  nameDayLabel: _propTypes2.default.string,
  tomorrowLabel: _propTypes2.default.string,
  emptyCartTitle: _propTypes2.default.string
};
Header.defaultProps = {
  name: '',
  pageTitle: '',
  cartSum: '',
  onNewOrder: null,
  onNewProduct: null,
  onCart: null,
  logoutMethod: null,
  onSettings: null,
  onSearch: null,
  nameDayToday: '',
  nameDayTomorrow: '',
  tomorrowLabel: (0, _reactI18n.__)('zajtra'),
  changeCart: function changeCart() {},
  logo: null,
  className: '',
  carts: null,
  selectedCart: '',
  role: '',
  menuOffset: 70,
  activeCartContent: [],
  maxCartItems: 6,
  toCartTitle: '',
  searchPlaceholder: (0, _reactI18n.__)('Hľadať produkt'),
  emptyCartTitle: (0, _reactI18n.__)('Košík je prázdny'),
  nameDayLabel: (0, _reactI18n.__)('Meniny má'),
  addLabel: 'Pridať produkt',
  headerMenuItems: [{
    label: (0, _reactI18n.__)('Používatelia'),
    icon: 'users',
    onClick: function onClick() {
      return console.log('users');
    },
    rolesExcluded: ['b2b_user']
  }, {
    label: (0, _reactI18n.__)('Spoločnosť'),
    icon: 'building',
    onClick: function onClick() {
      return console.log('company');
    },
    rolesExcluded: ['b2b_user']
  }, {
    label: (0, _reactI18n.__)('Môj účet'),
    icon: 'profile',
    onClick: function onClick() {
      return console.log('my account');
    },
    rolesExcluded: []
  }, {
    label: (0, _reactI18n.__)('Odhlásiť sa'),
    icon: 'power-off',
    onClick: function onClick() {
      return console.log('logout');
    },
    rolesExcluded: []
  }]
};

exports.default = Header;
Header.__docgenInfo = [{
  'description': '',
  'displayName': 'Header',
  'methods': [{
    'name': 'onUserClick',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'onCartClick',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'handleKeyPress',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'event',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'cartItemsText',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'renderTitle',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }],
  'props': {
    'name': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'pageTitle': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'cartSum': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'onNewOrder': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'onNewProduct': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'onCart': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'logoutMethod': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'changeCart': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'onSettings': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'onSearch': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'logo': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'nameDayToday': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'nameDayTomorrow': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'selectedCart': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'carts': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'custom',
          'raw': '{}'
        }
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'headerMenuItems': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'custom',
          'raw': '{}'
        }
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '[\n  {\n    label: __(\'Pou\u017E\xEDvatelia\'),\n    icon: \'users\',\n    onClick: () => console.log(\'users\'),\n    rolesExcluded: [\'b2b_user\']\n  },\n  {\n    label: __(\'Spolo\u010Dnos\u0165\'),\n    icon: \'building\',\n    onClick: () => console.log(\'company\'),\n    rolesExcluded: [\'b2b_user\']\n  },\n  {\n    label: __(\'M\xF4j \xFA\u010Det\'),\n    icon: \'profile\',\n    onClick: () => console.log(\'my account\'),\n    rolesExcluded: []\n  },\n  {\n    label: __(\'Odhl\xE1si\u0165 sa\'),\n    icon: \'power-off\',\n    onClick: () => console.log(\'logout\'),\n    rolesExcluded: []\n  }\n]',
        'computed': false
      }
    },
    'activeCartContent': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'custom',
          'raw': '{}'
        }
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '[]',
        'computed': false
      }
    },
    'maxCartItems': {
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '6',
        'computed': false
      }
    },
    'role': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'menuOffset': {
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '70',
        'computed': false
      }
    },
    'toCartTitle': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'addLabel': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'Prida\u0165 produkt\'',
        'computed': false
      }
    },
    'searchPlaceholder': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '__(\'H\u013Eada\u0165 produkt\')',
        'computed': true
      }
    },
    'nameDayLabel': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '__(\'Meniny m\xE1\')',
        'computed': true
      }
    },
    'tomorrowLabel': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '__(\'zajtra\')',
        'computed': true
      }
    },
    'emptyCartTitle': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '__(\'Ko\u0161\xEDk je pr\xE1zdny\')',
        'computed': true
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Header/Header.js'] = {
    name: 'Header',
    docgenInfo: Header.__docgenInfo,
    path: 'src/Header/Header.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Header/Header.js
// module id = 312
// module chunks = 1